import { useFeature } from '@growthbook/growthbook-react';
import { FEATURE_FLAG_KEYS } from '../../../config/growthbook';

const useRenewQuoteFeature = () => {
  return useFeature(FEATURE_FLAG_KEYS.REBUILD_RENEWALS);
};

export default useRenewQuoteFeature;
